import React, { useState } from 'react';
import { adminAPI, authAPI, authUtils } from '../api/userAPI';

const AdminLogin = ({ onSuccess, onCancel }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      console.log('Admin login attempt with:', credentials.email);
      
      // Login directly using the API without updating AuthContext
      const response = await authAPI.login(credentials);
      console.log('Admin login response:', response);
      
      // Store token for admin check
      authUtils.setToken(response.access_token);
      console.log('Token stored for admin check');
      
      // Get user profile with the token
      const userData = await authAPI.getProfile(response.access_token);
      console.log('Admin user data:', userData);
      
      if (userData.role !== 'admin' && userData.role !== 'super_admin') {
        console.log('User is not admin, role:', userData.role);
        // Clear token if not admin
        authUtils.logout();
        throw new Error('Access denied. Admin privileges required.');
      }

      console.log('Admin verification successful, calling onSuccess');
      // Store user data for admin session
      authUtils.setUser(userData);

      if (onSuccess) {
        onSuccess(userData);
      }
    } catch (err) {
      console.error('Admin login error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-form">
        <h2>🔐 Admin Login</h2>
        <p>Enter your admin credentials to access the admin panel.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Admin Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              required
              placeholder="admin@biodawn.com"
              className="form-input"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
              placeholder="Enter admin password"
              className="form-input"
            />
          </div>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <div className="form-actions">
            <button
              type="submit"
              disabled={loading}
              className="admin-login-button"
            >
              {loading ? 'Signing In...' : 'Sign In as Admin'}
            </button>
            
            <button
              type="button"
              onClick={onCancel}
              className="cancel-button"
            >
              Cancel
            </button>
          </div>
        </form>
        
        <div className="admin-credentials">
          <h4>Demo Admin Credentials:</h4>
          <p><strong>Email:</strong> admin@biodawn.com</p>
          <p><strong>Password:</strong> admin123456</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
